import MarkDownRenderer from '../../../../commonComponents/MarkDownRender/MarkDownRender.Component';

export const markdownContent = `
# **HawkClient CLI**

The official command-line tool for running API collections with **HawkClient**.

---

## 📦 **Installation**

Install the CLI globally using npm:

\`\`\`bash
npm install -g hawkclient-cli
\`\`\`


---

## ▶️ **Run a Collection**
Make sure you are inside your **HawkClient workspace directory**, where collections and environments are stored.

Use the following command to execute a collection:

\`\`\`bash
hawkclient run --collectionName "demo" --env "dev" --envVar url=https://hawkclient.com
\`\`\`

---

## ⚙️ **CLI Options**

| Option | Type | Required | Description |
|------|------|----------|-------------|
| **--collectionName** | String | Yes | Name of the collection to run |
| **--env** | String | No | Name of the environment to use (optional) |
| **--htmlReport** | String | No | Name of the HTML file to save execution results |
| **--envVar**     | Array  | No | Environment variable override (key=value). Can be used multiple times |
---

## 📸 **Example Output**

![HawkClient CLI](/docs/hawkclient-cli.png)
`;

const HawkClientCLIInstructions = () => {
    return (
        <MarkDownRenderer
            title="HawkClient CLI"
            markDownText={markdownContent}
        />
    );
};

export default HawkClientCLIInstructions;
